import React from "react";
import Translator from "Languages/Utility/Translator";

export const checkMaterial = (value) => {
  if (value.includes("UPVC") || value.includes("upvc") || value === "U") {
    return "UPVC";
  } else if (
    value.includes("alu") ||
    value.includes("ALU") ||
    value.includes("Aluminum") ||
    value === "A" ||
    value === "Aluminum"
  ) {
    return "ALU";
  } else if (value === "lolayi" || value === "L") {
    return <Translator id='hinged' noSpan/>
  } else if (value === "keshoyi" || value === "K" || value === "R") {
    return <Translator id='sliding' noSpan/>
  } else if (value === "tarkibi" || value === "T") {
    return <Translator id='combinatory' noSpan/>
  } else {
    return "-";
  }
};

export const checkStype = (struct, winDoor) => {
  if (struct === 1 && winDoor === 1) {
    return 1;
  } else if (struct === 1 && winDoor === 2) {
    return 2;
  } else if (struct === 2 && winDoor === 1) {
    return 3;
  } else if (struct === 2 && winDoor === 2) {
    return 4;
  }
};

export const returnKey = (value) => {
  if (value.includes("UPVC") || value.includes("upvc") || value === "U") {
    return "upvc";
  } else if (
    value.includes("alu") ||
    value.includes("ALU") ||
    value === "A" ||
    value === "Aluminum"
  ) {
    return "alu";
  } else if (value === "lolayi" || value === "L") {
    return "lolayi";
  } else if (value === "keshoyi" || value === "K" || value === "R") {
    return "keshoyi";
  } else if (value === "T") {
    return "tarkibi";
  } else {
    return value;
  }
};
